import { callApi } from "@/api/callApi";
import { API_ENDPOINT, API_URL_USER_SERVICE } from "@/api/constant";
import Layout from "@/components/Layout/Layout";
import DetailsCard from "@/components/UI/DetailsCard";
import { IRolesResponse } from "@/interfaces/RolesResponse.interface";
import { formatDateTime, showToastNotification } from "@/utility/helper";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

interface StatesProp {
    role: IRolesResponse | null
}

const ViewRole = () => {
    const { id } = useParams();
    const [states, setStates] = useState<StatesProp>({
        role: null
    })

    const fetchRoleDetail = async () => {
        try {
            const PATH = `${API_URL_USER_SERVICE}${API_ENDPOINT.roles}/${id}`;
            const res = await callApi<IRolesResponse>(PATH, { method: 'GET' });
            setStates((prev) => ({ ...prev, role: res }));
        } catch (error) {
            const err = error as { message: string };
            showToastNotification('danger', err.message);
            console.log('error in role submit', error);
        }
    }

    useEffect(() => {
        if (id) fetchRoleDetail()
    }, [id]);

    const rolesDetail = [
        { label: 'Role Name', value: states?.role?.name },
        { label: 'Created At', value: formatDateTime(states?.role?.createdAt, 'YYMMMDDHH') },
        { label: 'Last Update', value: formatDateTime(states?.role?.updatedAt, 'YYMMMDDHH') },
    ]

    return (
        <Layout>
            <div className="bg-white rounded-2xl space-y-4">
                <DetailsCard
                    title="Role Information"
                    details={rolesDetail}
                    columns={3}
                />
                <div className="p-5">
                    {
                        (states.role && states.role.permissions.length > 0) &&
                        states.role.permissions.map((item, idx) => {
                            return (
                                <div
                                    key={idx}
                                    className="flex items-center gap-10 border-b py-3 border-gray-200"
                                >
                                    <div className="w-3xs">
                                        <span className="capitalize">{item.resource}</span>
                                    </div>
                                    <div className="flex gap-3 flex-wrap">
                                        {item.actions.map((act, aIdx) => {
                                            return (
                                                <span
                                                    key={aIdx}
                                                    className="bg-primary text-white px-4 py-1 rounded-xl"
                                                >
                                                    {act}
                                                </span>
                                            )
                                        })}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </Layout>
    )
}

export default ViewRole;